<template lang="pug"> 
  .HeaderContainer  
    header.Header
      .HeaderBlock
        button#HeaderSidebarToggleButton.Button.-primary.ControlButton(@click="$emit('accion')")
          i.fa.fa-bars.Icon(aria-hidden='true')
      .HeaderBlock
      .HeaderBlock
        nav.ProfileNav
          .Dropdown.NavItem.Notifications
            button.btn.DropdownToggle.NavLink.NotificationsLink(href='#' @click="desplegarMensajes=desplegar(desplegarMensajes)",style="background-color: rgb(255, 255, 255); border:none")
              i.fa.fa-bell-o
              sup
                span.Counter {{mensajes.length}}
            .DropdownContent.-end(v-bind:style='{display: desplegarMensajes}', v-if='mensajes', v-for='item of mensajes', :key='item.id')  {{item.mensaje}}   
          .Dropdown.NavItem.Profile
            button.btn.DropdownToggle.NavLink.ProfileLink( @click="desplegarUsuario= desplegarUsuario==0 ? 1:0" ,style="background-color: rgb(255, 255, 255); border:none")
                
              .Name {{infoUsuario.user}} 
            .DropdownContent.-end(v-bind:class="{'efecto_desaparece_dp' : desplegarUsuario==0 ? true:false ,  'efecto_aparece_dp' : desplegarUsuario==1 ? true:false}")
              nav.Nav(style="background-color : white!important; width : 100%;  box-shadow:0!important; -moz-box-shadow:0!important; -webkit-box-shadow:0!important")
                router-link(to='/resetPassword' @click.native="isShowModal=true")
                    i.fa.fa-user.Icon    
                    |Reset Password   
                router-link(to="/" @click.native="$emit('logout')")
                    i.fa.fa-power-off.Icon    
                    | Logout
</template>
<script>

export default {
  props:['infoUsuario'],
  data(){
    return {
      mensajes:[],
      desplegarUsuario : 0,
      desplegarMensajes : 'none', 
    }
  },
  components:{
     
  },
  created()
  {
    this.$router.addRoutes([{path: '/cuenta', component : require('./userProfile.vue').default}])
    this.infoUsuario.user=this.$info.nameUser 
  },
  methods : {
        desplegar(variable){
         return variable=='none' ? 'block':'none'
        }
         
  }
}
</script>
<style>
    .efecto_desaparece_dp{      
        visibility: hidden;
        opacity: 0;  
        max-height: 0;  
        transition: all 0.3s ease .3s;
        -moz-transition:all 0.3s ease .3s;
        -webkit-transition:all 0.3s ease .3s;
        -o-transition:all 0.3s ease .3s;
        display: flex!important;;
    }
    .efecto_aparece_dp{          
        visibility: visible; 
        max-height: 500px;
        -moz-transition: max-height 0.7s ease-in;
        -o-transition: max-height 0.7s ease-in;
        -webkit-transition: max-height 0.7s ease-in;
        transition: max-height 0.7s ease-in; 
        display: flex!important;
        overflow: auto;
        overflow-y:hidden;
       
    }
</style>
